import type { components } from '@fluencelabs/vodopad-admin-api'
import { useQuery } from '@tanstack/react-query'

import client from '@/api/client'
import { unwrapApiData } from '@/api/unwrapApiResult'

type VmConfigurationDto = components['schemas']['VmConfigurationDto']

async function fetchVmConfigurations(): Promise<VmConfigurationDto[]> {
  const result = await client.GET('/v1/configurations/virtual_machines')
  return unwrapApiData(result, 'Failed to fetch VM configurations').items
}

export function useVmConfigurations() {
  const query = useQuery({
    queryKey: ['vmConfigurations'],
    queryFn: fetchVmConfigurations,
    staleTime: 30 * 60 * 1000,
  })

  return {
    configurations: query.data ?? [],
    query,
  }
}
